import { useEffect, useState } from 'react';
import PMGProjectIcon from '../../assets/icons/pmg-project.svg';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button/Button';
import SearchBar from '../../components/Common/SearchBar/SearchBar';
import CustomPagination from '../../components/Common/CustomPagination/CustomPagination';
import CustomTable from '../../components/Common/CustomTable/CustomTable';
import { EditOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { addInternalOrderMaster, editInternalOrderMaster, getInternalOrderMasterListing } from '../../redux/adminUnitReportSlice/adminUnitReportSlice';
import openNotification from '../../components/Common/OpenNotification';
import AddInternalOrderMaster from '../../components/Modals/AddInternalOrderMaster';
import { PATHNAME } from '../../pathname';

const InternalOrderMaster = () => {
        const [searchValue, setSearchValue] = useState('');
        const [currentPage, setCurrentPage] = useState(1);
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [editProject, setEditProject] = useState({});
        const [ioNo, setIoNo] = useState('');
        const dispatch = useDispatch();
        const navigate = useNavigate();
        const { internalOrderMasterListing, totalInternalOrderMasterListing } = useSelector((state) => state.unitReport);

        const handleAdd = async (formData) => {
                let response;
                if (editProject && Object.keys(editProject).length > 0) {
                        response = await dispatch(editInternalOrderMaster(formData));
                } else {
                        response = await dispatch(addInternalOrderMaster(formData));
                }

                const status = response?.payload?.status;

                if (status === 'success') {
                        dispatch(
                                getInternalOrderMasterListing({
                                        page: currentPage,
                                        size: '10',
                                        search: searchValue,
                                }),
                        );
                        openNotification('success', editProject?.IO_NO ? 'Updated' : 'Added', 'Success');
                        setIsModalOpen(false); // ✅ Only close on success
                }

                return { status }; // ✅ Return status for child to handle
        };

        const pageSize = 10; // Items per page
        const columns = [
                {
                        title: 'Project Name',
                        dataIndex: 'PROJ_NAME',
                        key: 'PROJ_NAME',
                        width: 250,
                        fixed: 'left',
                        render: (text, record) => (
                                <div className="flex items-center justify-between gap-2">
                                        <span>{text}</span>
                                        <EditOutlined
                                                className="text-blue-500 cursor-pointer"
                                                onClick={() => {
                                                        setEditProject(record);
                                                        setIsModalOpen(true);
                                                }}
                                        />
                                </div>
                        ),
                },
                {
                        title: 'IO Number',
                        dataIndex: 'IO_NO',
                        key: 'IO_NO',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'Rev No.',
                        dataIndex: 'REV_NO',
                        key: 'REV_NO',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'CUSTOMER NAME',
                        dataIndex: 'CUST_NAME',
                        key: 'CUST_NAME',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'ADMIN SECTION NAME',
                        dataIndex: 'ADMIN_SECTION_NAME',
                        key: 'ADMIN_SECTION_NAME',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'Zero Date',
                        dataIndex: 'ZERO_DATE',
                        key: 'ZERO_DATE',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
        ];

        useEffect(() => {
                dispatch(
                        getInternalOrderMasterListing({
                                page: currentPage,
                                size: '10',
                                search: searchValue,
                        }),
                );
        }, [currentPage, searchValue]);

        return (
                <div className="pb-14">
                        <div className="px-5 flex flex-col gap-6 pt-4">
                                <div className="flex gap-3">
                                        {/* <img
                                                src={PMGProjectIcon}
                                                alt="region"
                                        /> */}
                                        <div>
                                                <div className="font-inter font-semibold text-[18px] leading-[24px] tracking-[0%] text-[#101828]">Internal Order Master</div>
                                                <div className="font-inter font-normal text-[13px] leading-[20px] tracking-[0%] text-[#475467]">List of internal order master</div>
                                        </div>
                                </div>
                                <div className="text-gray-500 text-sm flex justify-start">* All figures are in Rupees (in lakhs).</div>
                                <div className="mt-[8px] flex justify-between">
                                        <SearchBar
                                                className="!w-[330px]"
                                                onSearch={setSearchValue}
                                                placeholder="Search by Project Name"
                                        />

                                        <div className="flex">
                                                <div className="mr-4">
                                                <Button onClick={() => navigate(PATHNAME.ADMIN_UPLOAD_CSV_FILES_INTERNAL_ORDER_MASTER)}
                                                text="Upload"
                                                variant="primary"
                                                />

                                                </div>

                                                <div className="flex gap-[12px]">
                                                <Button
                                                        text="+ Add Internal Order"
                                                        variant="primary"
                                                        onClick={() => {
                                                                setIsModalOpen(true);
                                                                setEditProject({});
                                                        }}
                                                />
                                        </div>
                                         
                                        </div>

                                        
                                </div>
                                <div className=" flex flex-col gap-6">
                                        <CustomTable
                                                dataSource={internalOrderMasterListing}
                                                columns={columns}
                                        />
                                        <div>
                                                <CustomPagination
                                                        totalItems={totalInternalOrderMasterListing}
                                                        pageSize={pageSize}
                                                        currentPage={currentPage}
                                                        setCurrentPage={setCurrentPage}
                                                />
                                        </div>
                                </div>
                                <AddInternalOrderMaster
                                        open={isModalOpen}
                                        onCancel={() => {
                                                setIsModalOpen(false);
                                                setEditProject({});
                                        }}
                                        onSubmit={handleAdd}
                                        initialData={editProject}
                                        setEditInternalOrder={setEditProject}
                                />
                        </div>
                </div>
        );
};

export default InternalOrderMaster;
